import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import global_45auth_45global from "/app/middleware/global-auth.global.ts";
import maintenance_45global from "/app/middleware/maintenance.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  global_45auth_45global,
  maintenance_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  loading: () => import("/app/middleware/loading.ts"),
  "no-cache": () => import("/app/middleware/no-cache.ts")
}